// src/slices/branchesSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SearchParams } from '@/app/lib/schemas/types/search-params';

interface SearchParamsState {
  params: SearchParams;
}

const initialState: SearchParamsState = {
  params: {
    query: '',
    levels: [],
    page: '1'
  }
};

const SearchParamsSlice = createSlice({
  name: 'searchParams',
  initialState,
  reducers: {
    updateSearchParams: (
      state: SearchParamsState,
      action: PayloadAction<SearchParams>
    ) => {
      state.params = action.payload;
    },
    clearSearchParams: (state: SearchParamsState) => {
      state.params = { query: '', levels: [], page: '1' };
    }
  }
});

export const { updateSearchParams, clearSearchParams } =
  SearchParamsSlice.actions;
export default SearchParamsSlice.reducer;
